document.addEventListener(
    "DOMContentLoaded", () => {

        // Main Menu Code
        // Open Menu
        var headerMainMenuBtn = document.querySelector('.mobile-content .menu-button');
        headerMainMenuBtn.addEventListener('click', event => {
            event.preventDefault();

            if (!document.body.classList.contains('menu-open')) {
                document.body.classList.add('menu-open');

                // Stops it scrolling back to the top
                document.body.style.top = '-' + window.scrollY + 'px';
                document.body.style.position = 'fixed';
            }
            else {
                document.body.classList.remove('menu-open');

                // Make sure it doesnt scroll back to the top
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        });

        // Close Menu
        var mainMenuBtn = document.querySelector('.main-menu .header-menu-button');
        if (mainMenuBtn) {
            mainMenuBtn.addEventListener('click', event => {
                event.preventDefault();
                document.body.classList.remove('menu-open');

                // Make sure it doesnt scroll back to the top
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            });
        }
        // Close Menu Overlay
        var mainMenuOverlay = document.querySelector('.main-menu-overlay');
        mainMenuOverlay.addEventListener('click', event => {
            event.preventDefault();
            document.body.classList.remove('menu-open');

            // Make sure it doesnt scroll back to the top
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        });

        // Menu Accordions
        var menuAccordions = document.querySelectorAll('.main-menu .menu-acc');
        menuAccordions.forEach(function (menuAccordion, i) {

            menuAccordion.addEventListener('click', event => {
                event.preventDefault();

                var menuAccordionContent = menuAccordion.parentElement.querySelector('.menu-acc-content');

                // Remove all existing menu open and closed items
                var subMenus = menuAccordionContent.querySelectorAll(':scope > ul');
                subMenus.forEach(function (subMenu, i) {
                    subMenu.classList.remove('menu-closed');
                    subMenu.classList.remove('menu-open');
                });

                if (menuAccordion.classList.contains('menu-open')) {
                    menuAccordion.classList.remove('menu-open');
                    menuAccordionContent.setAttribute('style', 'height: 0px;');
                } else {
                    // Get the first menu and open it
                    var firstMenu = menuAccordionContent.querySelector(':scope > ul');
                    firstMenu.classList.add('menu-open');

                    menuAccordion.classList.add('menu-open');
                    var menuHeight = menuAccordionContent.querySelector(':scope > ul').clientHeight;
                    menuAccordionContent.setAttribute('style', 'height: ' + menuHeight + 'px;');
                }
            });
        });

        // Sub Menu Links
        var subMenuLinks = document.querySelectorAll('.main-menu .sub-menu-link');
        subMenuLinks.forEach(function (subMenuLink, i) {

            subMenuLink.addEventListener('click', event => {
                event.preventDefault();

                // Get the destination details
                var destinationMenuID = subMenuLink.dataset.menuId;
                var destinationMenu = document.querySelector('.main-menu #' + destinationMenuID);

                // Get the accordion content container, should always be in the same place
                var menuAccordionContent = subMenuLink.parentElement.parentElement.parentElement;

                // Close all existing menus
                var exitingMenu = menuAccordionContent.querySelector('.menu-open');
                exitingMenu.classList.remove('menu-open');

                if (subMenuLink.dataset.menuDirection != 'back') {
                    exitingMenu.classList.add('menu-closed');
                }

                // Open desintation menu
                destinationMenu.classList.remove('menu-closed');
                destinationMenu.classList.add('menu-open');
                var menuHeight = destinationMenu.clientHeight;
                menuAccordionContent.setAttribute('style', 'height: ' + menuHeight + 'px;');
            });
        });
    }
);
